import { Dispatch, MutableRefObject, SetStateAction, useEffect } from 'react';

/**
 * Закрывает dropdown при клике вне его области.
 *
 * @param targetRef - Ref на элемент dropdown
 * @param togglerRef - Ref на элемент-переключатель dropdown
 * @param setIsDropdownVisible - Функция для изменения видимости dropdown
 * @param shouldHandleTogglerRef - Учитывать ли клик по togglerRef (по умолчанию true)
 */
export function useCloseDropdownOnClickOutside(
    targetRef: MutableRefObject<HTMLElement | null>,
    togglerRef: MutableRefObject<HTMLElement | null>,
    setIsDropdownVisible: Dispatch<SetStateAction<boolean>>,
    shouldHandleTogglerRef: boolean = true
) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            const shouldCheckToggler = shouldHandleTogglerRef
                ? togglerRef.current && !togglerRef.current.contains(event.target as Node)
                : true;

            if (
                targetRef.current &&
                !targetRef.current.contains(event.target as Node) &&
                shouldCheckToggler
            ) {
                setIsDropdownVisible(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldHandleTogglerRef]);
}
